module.exports = __webpack_public_path__ + "assets/img/thumb-LJ-Hooker-eBook.36b7ba83.webp";